export default "__VITE_ASSET__Blh2cIVd__"